import React from 'react';

export const formatTin = (value, type) => {
  const d = value.replace(/\D/g, '').slice(0, 9);
  if (type === 'ein') return d.length > 2 ? `${d.slice(0, 2)}-${d.slice(2)}` : d;
  return [d.slice(0, 3), d.slice(3, 5), d.slice(5)].filter(Boolean).join('-');
};

export const isValidTin = (value) => value.replace(/\D/g, '').length === 9;

export const TaxIdFields = ({ type, value, onType, onValue, testPrefix = 'tax-id' }) => (
  <div>
    <label className="block text-sm font-medium text-slate-300 mb-2">Taxpayer ID (for your IRS Form 8824)</label>
    <div className="flex gap-2 mb-2">
      {[['ssn', 'SSN (individual)'], ['ein', 'EIN (business)']].map(([k, label]) => (
        <button key={k} type="button" onClick={() => { onType(k); onValue(formatTin(value, k)); }} data-testid={`${testPrefix}-type-${k}`}
          className={`flex-1 py-2 rounded-lg text-sm border ${type === k ? 'bg-emerald-500/20 border-emerald-500 text-emerald-300' : 'border-slate-600 text-slate-400'}`}>{label}</button>
      ))}
    </div>
    <input value={value} onChange={(e) => onValue(formatTin(e.target.value, type))} inputMode="numeric" autoComplete="off"
      placeholder={type === 'ein' ? '12-3456789' : '123-45-6789'} data-testid={`${testPrefix}-input`}
      className="w-full bg-slate-900/50 border border-slate-600 rounded-lg px-4 py-3 text-white font-mono placeholder-slate-500 focus:border-emerald-500 outline-none" />
    <p className="text-xs text-slate-500 mt-1">Stored encrypted. Shown only as the last 4 digits, except on your tax forms.</p>
  </div>
);
